import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Button, Form, Header, Message } from 'semantic-ui-react';
import { withConfig } from '../config/config.context';
import store, { getParameterByName } from '../shared/Store';
import { getString } from '../utils';
import { markdownUrlify } from '../utils/stringUtils';
import LoginLayout from './LoginLayout';

const translationPrefix = 'login';

class LoginScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      login: getParameterByName('email'),
      // eslint-disable-next-line react/destructuring-assignment
      stayConnected: this.props.config?.screens?.login?.stayConnected,
      error: null,
      message: null,
    };
  }

  handleLogin = async (evt) => {
    evt.preventDefault();
    evt.stopPropagation();
    const { login, password, stayConnected } = this.state;
    await store.login(login, password, stayConnected);
    if (store.isLoggedIn()) {
      this.forceUpdate();
    } else {
      this.setState({ error: getString(`${translationPrefix}.error-wrong-login-password`) });
    }
  };

  handleChange = (e, { name, value, checked }) => {
    this.setState({ [name]: value || checked, message: null, error: null });
  };

  render() {
    const { config } = this.props;
    const design = config?.design ?? {};
    const { login, password, stayConnected, error, message } = this.state;
    if (store.isLoggedIn()) {
      return <Redirect to="/" />;
    }
    const { primaryColor: color } = design;

    const notYetRegistered = getString(`${translationPrefix}.not-yet-registered`);
    return (
      <LoginLayout>
        <div className="platform-opened">
          <Header as="h2" style={{ color }} textAlign="center">
            {getString(`${translationPrefix}.connect-to-your-account`)}
          </Header>
          <Form.Input
            fluid
            icon="user"
            iconPosition="left"
            placeholder={getString(`${translationPrefix}.login`)}
            name="login"
            value={login || ''}
            onChange={this.handleChange}
          />
          <Form.Input
            fluid
            icon="lock"
            iconPosition="left"
            placeholder={getString(`${translationPrefix}.password`)}
            type="password"
            name="password"
            value={password || ''}
            onChange={this.handleChange}
          />
          <Form.Checkbox
            name="stayConnected"
            checked={stayConnected}
            label={getString(`${translationPrefix}.accept-save-data`)}
            onChange={this.handleChange}
          />

          <Button
            style={{ backgroundColor: color, color: 'white' }}
            fluid
            size="large"
            disabled={!login || !password}
            onClick={this.handleLogin}
          >
            {getString('btn.connect')}
          </Button>
          {!message && (
            <Link className="link--forgotten-password" to="/forgottenPassword">
              {getString(`${translationPrefix}.forgotten-password`)}
            </Link>
          )}
          {notYetRegistered && (
            <p className="text--not-yet-registered">{markdownUrlify(notYetRegistered)}</p>
          )}
          {message && (
            <div className="Login--MessageWrapper">
              <Message content={message} />
            </div>
          )}
          {error && (
            <div className="Login--MessageWrapper">
              <Message error header={getString(`${translationPrefix}.error`)} content={error} />
            </div>
          )}
        </div>
      </LoginLayout>
    );
  }
}

LoginScreen.propTypes = {
  config: PropTypes.object.isRequired,
};

export default withConfig(LoginScreen);
